import { Constants } from "@eagerdog/constants";
import { IUser } from "@eagerdog/interfaces";

import { helperService } from "src/services/helper.service";

const minimumAmount = 10;

export const showPointsReminder = (user: IUser) => user.show_points_reminder !== false;

export const pointsReminderEnabled = (user: IUser, onBehalf?: string, onBehalfEmail?: string) => {
  if (!helperService.isLoggedIn()) return false;
  if (user.user_type !== Constants.user_type.owner) return false;
  if (onBehalf || onBehalfEmail) return false;
  return showPointsReminder(user);
};

export const maxRedeemablePoints = (availablePoints: number, redeemableAmount: number) => {
  if ((redeemableAmount || 0) < minimumAmount) return 0;
  const cartMax = Math.floor(redeemableAmount * Constants.wallet.points_to_dollar_ratio);
  return Math.min(availablePoints, cartMax);
};

export const pointsToDollars = (points: number) => points / Constants.wallet.points_to_dollar_ratio;

/** Largest dollar amount, to the cent, that does not round above the point cap. */
export const maxDollarInput = (points: number) => {
  const cents = Math.floor(points / (Constants.wallet.points_to_dollar_ratio / 100));
  return (cents / 100).toFixed(2);
};

export const dollarsToPoints = (raw: string) => {
  const dollars = parseFloat(raw);
  if (isNaN(dollars) || dollars <= 0) return 0;
  return Math.round(dollars * Constants.wallet.points_to_dollar_ratio);
};

export const dollarsLabel = (dollars: number) =>
  `$${dollars.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
